import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Row from 'react-bootstrap/Row';
import { LinkContainer } from 'react-router-bootstrap';

import NotFoundImgSrc from '../../assets/images/404.svg';
import { useDocumentTitle } from '../app/hooks/use-document-title';

// Page for handling 404 errors
export const NotFound = () => {
  useDocumentTitle('Not Found');
  return (
    <Container className="justify-content-center align-items-center" fluid>
      <Row className="d-flex justify-content-center align-items-center text-center">
        <Col className="" lg={12} xl={8}>
          <Image
            alt="Illustration of a man in front of a billboard with the text 404"
            className="d-block my-5 img-404 mx-auto"
            loading="lazy"
            src={NotFoundImgSrc}
          />
          <div className="my-5">
            <h1 className="display-5 fw-bold text-primary text-center">
              Uh oh! It looks like you might be lost.
            </h1>
            <h3 className="">Let&apos;s try starting retracing your steps.</h3>
            <LinkContainer to="/">
              <Button
                className="btn btn-primary px-5 fs-3 py-3 my-5 btn-drop-shadow rounded-0"
                type="button"
              >
                Go Home
              </Button>
            </LinkContainer>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
